import { Component, input, model, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { HlmIconComponent } from '@helipagos-ng/ui-icon-helm';
import { HlmButtonDirective } from '@helipagos-ng/ui-button-helm';
import {
  HlmCardContentDirective,
  HlmCardDirective,
  HlmCardFooterDirective,
  HlmCardHeaderDirective,
  HlmCardTitleDirective,
} from '@helipagos-ng/ui-card-helm';
import { ReactiveFormsModule } from '@angular/forms';
import { HlmInputDirective } from '@helipagos-ng/ui-input-helm';
import { HlmLabelDirective } from '@helipagos-ng/ui-label-helm';
import { lucideLoader2 } from '@ng-icons/lucide';
import { provideIcons } from '@ng-icons/core';
@Component({
  selector: 'lib-auth-container',
  standalone: true,
  imports: [
    HlmIconComponent,
    HlmButtonDirective,
    HlmCardDirective,
    HlmCardHeaderDirective,
    HlmCardTitleDirective,
    HlmCardContentDirective,
    HlmCardFooterDirective,
    ReactiveFormsModule,
    TranslateModule,
  ],
  providers: [provideIcons({ lucideLoader2 })],
  templateUrl: './auth-container.component.html',
})
export class AuthContainerComponent {
  public loading = model<boolean>(false);
  public redirecting = input<boolean>(false);

  public headerTXT = input.required<string>();

  public btnLabel = input.required<string>();
  public btnClick = output<void>();

  public linkLabel = input<string>();
  public linkClick = output<void>();

  public disabled = model<boolean>(false);

  constructor() {}
}
